import * as React from "react";
import { useCLEcommContext } from "../../../../../context/modules/EcommContent/ContactLensesEcommContent/context/CLEcommContext.js";
const useCLDeliveryIndicatorConfig = () => {
  const { state, selectors } = useCLEcommContext();
  const lineItemDrafts = selectors.getLineItemDrafts(state, void 0);
  const [isConfiguratorValid] = selectors.isConfiguratorValid(state);
  const config = React.useMemo(
    () => ({
      // Check if there is at least one line item draft, meaning the user has configured at least one prescription.
      hasConfiguredLineItems: lineItemDrafts.length > 0,
      // Check that all required information has been filled in, i.e for both the left and right eye if enabled
      validLineItemDrafts: isConfiguratorValid ? lineItemDrafts : []
    }),
    [lineItemDrafts, isConfiguratorValid]
  );
  return config;
};
export {
  useCLDeliveryIndicatorConfig
};
//# sourceMappingURL=use-cl-delivery-indicator-config.js.map
